module.exports = __webpack_public_path__ + "static/media/carousel1.c3c39a1d.jpg";